import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function PasswordResetRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const hashParams = new URLSearchParams(location.hash.replace('#', ''));
    
    // Check if this is a password recovery link
    const isRecovery = urlParams.get('type') === 'recovery' || hashParams.get('type') === 'recovery';
    
    if (isRecovery) {
      // Get tokens from URL or hash
      const accessToken = urlParams.get('access_token') || hashParams.get('access_token');
      const refreshToken = urlParams.get('refresh_token') || hashParams.get('refresh_token');
      
      if (accessToken && refreshToken) {
        // Redirect to reset password page with tokens in hash
        navigate(`/reset-password#access_token=${accessToken}&refresh_token=${refreshToken}&type=recovery`);
      } else {
        // If tokens are missing, redirect to auth page
        navigate('/auth');
      }
    }
  }, [navigate, location]);

  return null;
}